module.exports = __webpack_public_path__ + "static/media/this_is_relay_thumb_home.76fb36fa.mp4";